<template>
  <v-app-bar app clipped-left>
    <v-app-bar-nav-icon
      @click.stop="drawer = !drawer"
      v-if="isHomeRoute"
    ></v-app-bar-nav-icon>
    <v-btn icon class="hidden-xs-only" @click.prevent="homeButtonClick">
      <v-icon large>home</v-icon>
    </v-btn>
    <v-btn
      icon
      class="hidden-xs-only mr-2 ml-2"
      @click.prevent="backButtonClick"
    >
      <v-icon size="30">arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title>Think Home</v-toolbar-title>
    <v-spacer></v-spacer>
    <span class="ma-4">{{
      this.$store.state.UserStore.user.firstName +
        ' ' +
        this.$store.state.UserStore.user.lastName
    }}</span>
    <v-avatar color="white" size="36"> </v-avatar>
  </v-app-bar>
</template>

<script>
export default {
  components: {},

  props: {
    source: String
  },

  data: () => ({
    drawer: null
  }),

  created() {
    this.$vuetify.theme.dark = true
  },

  methods: {
    homeButtonClick: function(e) {
      // e.path[1].blur()
      this.$router.push('/projects')
    },
    backButtonClick: function(e) {
      this.$router.go(-1)
    }
  },
  computed: {
    currentRootTitle() {
      return this.$route.name
    },
    isHomeRoute() {
      return this.$route.path === '/'
    }
  }
}
</script>
